// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgDownFilled16 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 16 16"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path d="M5.46967 7.53033C5.17678 7.23744 5.17678 6.76256 5.46967 6.46967C5.76256 6.17678 6.23744 6.17678 6.53033 6.46967L8 7.939L9.46967 6.46967C9.73594 6.2034 10.1526 6.1792 10.4462 6.39705L10.5303 6.46967C10.8232 6.76256 10.8232 7.23744 10.5303 7.53033L8.53033 9.53033C8.23744 9.82322 7.76256 9.82322 7.46967 9.53033L5.46967 7.53033Z" />
			</Svg>
		);
	}
);
SvgDownFilled16.defaultProps = {
	size: 16,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgDownFilled16;
